import React from 'react';
import Logo from '../Logo';

const DashboardFooter = ({ couple, onContactClick }) => {
  return (
    <footer className="bg-white border-t border-neutral-200 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Logo className="h-8" />
            <div className="hidden sm:block h-6 w-px bg-neutral-200" />
            <p className="text-sm text-neutral-600">
              Tu lista de regalos
            </p>
          </div>

          <div className="flex items-center gap-6 text-sm">
            <button
              onClick={onContactClick}
              className="text-neutral-600 hover:text-accent-600 transition-colors"
            >
              Contacto
            </button>
            
            <a
              href={`/lista/${couple?.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent-600 hover:text-accent-700 font-medium transition-colors"
            >
              Ver mi lista →
            </a>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-neutral-200 text-center">
          <p className="text-xs text-neutral-500">
            © {new Date().getFullYear()} SobreDigital. Hecho con 💛 en Argentina
          </p>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;